import { Database } from "../supabase.types";

export type ComedianAnalyticsTagRow =
  Database["public"]["Tables"]["comedian_analytics_tags"]["Row"];

export type ComedianAnalyticsTagInsert =
  Database["public"]["Tables"]["comedian_analytics_tags"]["Insert"];

export type ComedianAnalyticsTagUpdate =
  Database["public"]["Tables"]["comedian_analytics_tags"]["Update"];

/** Re-exported so consumers of the row type and the provider registry share
 * one import path (`@punchup/data/models`) — the registry itself lives in
 * `@punchup/analytics/tags` (data depends on analytics, not the reverse). */
export * from "@punchup/analytics/tags/registry";
export * from "@punchup/analytics/tags/config";
